import { createContext } from "react";
const UserContext=createContext();
export default UserContext;

// all the authentication logic 
// like login, forgot password, new account